import { createSelector } from '@reduxjs/toolkit';

export const selectIntercom = (state) => state.intercom;

export const selectCurrentIntercomUserHash = () => createSelector(selectIntercom, (intercom) => intercom.hash);

export const selectIntercomUnreadCount = () => createSelector(selectIntercom, (intercom) => intercom.count);
